const getToken = state => state.token;
const getAccess = state => state.access;
const getUser = state => state.user;

export default {
  getToken,
  getUser,
  getAccess,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js